/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Flow_Next_Tasks_DescriptionInputs */

const en_task_flow_next_tasks_description = /** @type {(inputs: Task_Flow_Next_Tasks_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Each resolution preselects one of these; people completing the activity may choose another.`)
};

const pt_br2_task_flow_next_tasks_description = /** @type {(inputs: Task_Flow_Next_Tasks_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cada resolução pré-seleciona uma destas; quem conclui a atividade pode escolher outra.`)
};

/**
* | output |
* | --- |
* | "Each resolution preselects one of these; people completing the activity may choose another." |
*
* @param {Task_Flow_Next_Tasks_DescriptionInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_flow_next_tasks_description = /** @type {((inputs?: Task_Flow_Next_Tasks_DescriptionInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Flow_Next_Tasks_DescriptionInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_flow_next_tasks_description(inputs)
	return pt_br2_task_flow_next_tasks_description(inputs)
});